import styled from 'styled-components';

export const ReportCssWrapper = styled.div`
  .table {
    --bs-table-bg: transparent;
    --bs-table-accent-bg: transparent;
    width: 100%;
    margin-bottom: 20px;
    color: var(--color-text-base, #212529);
    vertical-align: top;
    border-color: var(--color-border, #dbeae3) !important;
    caption-side: bottom;
    border-collapse: collapse;
    border-spacing: 0;
  }

  .divide-10 {
    height: 10px;
    width: 100%;
  }

  .divide-20 {
    height: 20px;
    width: 100%;
  }

  thead {
    border-style: none !important;
  }

  .table > thead {
    vertical-align: bottom;
  }

  tbody {
    border-style: solid;
    border-width: 0;
  }

  .table > tbody {
    vertical-align: inherit;
  }

  tr {
    border-style: solid;
    border-width: 0;
  }

  .vatreporttable thead tr {
    color: #ffffff !important;
    font-size: 14px !important;
    padding: 0.75rem 1.25rem !important;
    margin-bottom: 0 !important;
    background-color: var(--color-primary, #41aaaf) !important;
    border: 1px solid var(--color-border, #dbeae3) !important;
    font-weight: 600 !important;
    height: 45px;
  }

  th {
    text-align: inherit;
    text-align: -webkit-match-parent;
  }

  th {
    border-style: solid;
    border-width: 0;
  }

  th {
    text-align: left;
  }

  .table > :not(caption) > * > * {
    padding: 0.5rem 0.5rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  }

  .table > thead > tr > th {
    padding: 8px;
    line-height: 1.428571429;
    vertical-align: top;
    border-top: 1px solid #dddddd;
  }

  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #dddddd;
  }

  .table > thead > tr > th {
    vertical-align: middle;
  }

  .table > :not(:last-child) > :last-child > * {
    border-bottom-color: currentColor;
  }

  .table > thead:first-child > tr:first-child > th {
    border-top: 0;
  }

  td {
    border-style: solid;
    border-width: 0;
  }

  .vatreporttable tbody td {
    border: 1px solid var(--color-border, #dbeae3);
    height: 50px;
    font-size: 14px;
    font-weight: 450;
    color: var(--color-text-base, #212529);
    background: var(--color-surface-raised, #ffffff);
  }

  .table > tbody > tr > td {
    padding: 8px;
    line-height: 1.428571429;
    vertical-align: middle;
    border-top: 1px solid #dddddd;
  }

  .box {
    clear: both;
    margin: 0px 5px 25px 5px;
    padding: 0px;
  }

  .vatreporttable .box {
    background: var(--color-layout-bg, #e9f6f7) !important;
    text-align: center !important;
    width: 67px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    color: var(--color-primary, #41aaaf);
  }

  .box:after,
  .box:before {
    display: table;
    color: '';
  }

  td[tabindex] {
    position: relative;
  }

  .vatreporttable .rightalign {
    text-align: right;
  }

  .nbr {
    border-right: 1px solid var(--color-surface-raised, #ffffff) !important;
  }

  .nbb {
    border-bottom: 1px solid var(--color-surface-raised, #ffffff) !important;
  }

  .vatreporttable .subtotal,
  .vatreporttable .subtotal-2 {
    text-align: left;
    font-weight: 400 !important;
    font-size: 14px;
    font-style: italic;
    line-height: 18px;
    color: var(--color-text-muted, #5a6a6a);
  }

  .vatreporttable .subtotal {
    background-color: var(--color-surface, rgba(0, 0, 0, 0.03)) !important;
  }

  .nbt {
    border-top: 1px solid var(--color-surface-raised, #ffffff) !important;
  }

  .nbl {
    border-left: 1px solid var(--color-surface-raised, #ffffff) !important;
  }

  .notavailable {
    text-decoration: line-through;
    background-color: var(--color-surface, #f9f9f9) !important;
  }

  .space20 {
    height: 10px !important;
    background: transparent !important;
    border-left: 0px !important;
    border-right: 0px !important;
  }

  .value-field {
    position: relative;
  }

  .value-field:hover,
  .value-field:focus-within {
    background-color: var(--color-primary-soft, rgba(0, 0, 0, 0.1));
    padding: 8px 3px;
    text-align: center !important;

    > .show-on-hover {
      opacity: 1;
      pointer-events: auto;
    }

    > .value-field-span {
      opacity: 0;
    }

    /* Hide compared value and arrow on hover/focus - these are siblings of value-field-span */
    [id$="-compared-value"],
    [id$="-arrow-container"] {
      display: none !important;
    }
  }

  /* Keep action buttons in tab order; reveal on hover or keyboard focus */
  .show-on-hover {
    display: flex;
    justify-content: center;
    position: absolute;
    inset: 0;
    align-items: center;
    opacity: 0;
    pointer-events: none;
  }

  .show-on-hover:focus-within {
    opacity: 1;
    pointer-events: auto;
  }

  .icon-button-hover:hover {
    background-color: var(--color-primary, #41aaaf) !important;
    > span > .hover-icon {
      filter: invert(100%) sepia(100%) saturate(38%) hue-rotate(321deg)
        brightness(150%) contrast(184%);
    }
  }

  .hover-icon {
    filter: brightness(0) saturate(100%) invert(61%) sepia(2%) saturate(1632%)
      hue-rotate(151deg) brightness(94%) contrast(88%);
  }

  .hover-icon:hover {
    filter: invert(100%) sepia(100%) saturate(38%) hue-rotate(321deg)
      brightness(150%) contrast(184%);
  }

  /* UK VAT Return - Box 5 highlighted total row */
  .uk-vat-total-row {
    background-color: var(--color-layout-bg, #e9f6f7) !important;
  }

  .uk-vat-total-row td {
    background-color: var(--color-layout-bg, #e9f6f7) !important;
    font-weight: 600 !important;
  }

  .uk-vat-total-cell {
    color: var(--color-primary, #41aaaf) !important;
  }

  /* Match reconciliation PDF: hide interactive chrome while html2canvas runs */
  #vat-to-be-exported.generating-pdf button {
    visibility: hidden !important;
  }
  #vat-to-be-exported.generating-pdf [data-pdf-hide] {
    visibility: hidden !important;
  }
`;
